import { render, staticRenderFns } from "./clipboard_button.vue?vue&type=template&id=425c5804&"
import script from "./clipboard_button.vue?vue&type=script&lang=js&"
export * from "./clipboard_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports